/**
 * GinStyle
 */
export type GinStyle =
  | 'DRY_GIN'
  | 'AGED_GIN'
  | 'GIN_LIQUEUR'
  | 'NAVY_STRENGTH'
  | 'OLD_TOM'
  | 'PLYMOUTH'
  | 'SLOE'
  | 'OTHER';

export const GinStyle = {
  DryGin: 'DRY_GIN' as GinStyle,
  AgedGin: 'AGED_GIN' as GinStyle,
  GinLiqueur: 'GIN_LIQUEUR' as GinStyle,
  NavyStrength: 'NAVY_STRENGTH' as GinStyle,
  OldTom: 'OLD_TOM' as GinStyle,
  Plymouth: 'PLYMOUTH' as GinStyle,
  Sloe: 'SLOE' as GinStyle,
  Other: 'OTHER' as GinStyle,
};
